import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    theme: 'light',
    frameLoading: true,
    frameError: '',
    activePortal: '',
    activeSection: ''
  }),
  actions: {
    setFrameState({ loading = false, error = '' } = {}) {
      this.frameLoading = loading
      this.frameError = error
    }
  }
})
